// Add products to cart
window.addEventListener(
  "DOMContentLoaded",
  function (event) {
    let buttons = document.querySelectorAll(".cta-qa__option"),
      submit = document.querySelector(".cta-qa__submit"),
      submitText = submit.querySelector(".js-cta-qa-price"),
      instance = document.querySelector("cart-drawer"),
      variantID = document.querySelector(".PdpHero-variant.activeVar")
        ? document.querySelector(".PdpHero-variant.activeVar").dataset.id
        : submit.dataset.id,
      price,
      data,
      config;

    // Get quantity from the main product form
    const getQuantity = () => {
      const quantityInput = document.querySelector('input[name="quantity"]');
      return quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    };

    data = new FormData();
    data.append("id", variantID);
    data.append("quantity", getQuantity());
    data.append(
      "sections",
      instance.getSectionsToRender().map((section) => section.id)
    );
    data.append("sections_url", window.location.pathname);
    config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    config.body = data;
    document.querySelector(".drawer").classList.remove("is-empty");

    if (buttons.length) {
      buttons.forEach((button) => {
        button.addEventListener("click", function () {
          variantID = this.dataset.id;
          price = this.dataset.price;

          submitText.textContent = price;
          document
            .querySelector(".cta-qa__option--selected")
            .classList.remove("cta-qa__option--selected");
          this.classList.add("cta-qa__option--selected");

          data = new FormData();
          data.append("id", variantID);
          data.append("quantity", getQuantity());
          data.append(
            "sections",
            instance.getSectionsToRender().map((section) => section.id)
          );
          data.append("sections_url", window.location.pathname);
          config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];
          config.body = data;
        });
      });
    } else {
      data = new FormData();
      data.append("id", variantID);
      data.append("quantity", getQuantity());
      data.append(
        "sections",
        instance.getSectionsToRender().map((section) => section.id)
      );
      data.append("sections_url", window.location.pathname);
      config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      config.body = data;
    }

    submit.addEventListener("click", function () {
      const ctaList = document.querySelector(".cta-qa__list");
      const hasVariants = ctaList && ctaList.classList.contains("atc_has_variants");
      const selectedVariant = document.querySelector(".cta-qa__option--selected");
      
      // Only scroll if product has variants AND no variant is selected
      if (hasVariants && !selectedVariant) {
        if (window.innerWidth < 1025) {
          document.documentElement.scrollTop = 500;
        }
      } else {
        // Find the main product form and use its data
        const productForm = document.querySelector('form[action*="/cart/add"]');
        
        if (productForm) {
          // Use the actual form data from the main product form
          const formData = new FormData(productForm);
          
          // Add sections for cart drawer update
          if (instance) {
            formData.append('sections', instance.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
          }
          
          const currentConfig = fetchConfig("javascript");
          currentConfig.headers["X-Requested-With"] = "XMLHttpRequest";
          delete currentConfig.headers["Content-Type"];
          currentConfig.body = formData;
          
          // Add to cart if no variants OR variant is selected
          fetch("/cart/add.js", currentConfig)
            .then((response) => response.json())
            .then((cart_item) => {
              // Handle the response after adding the item to the cart
              if (instance) {
                instance.renderContents(cart_item);
              }
              const cartForm = document.querySelector(".cart-drawer__form");
              if (cartForm) {
                cartForm.style.display = "flex";
              }
              const drawer = document.querySelector(".drawer");
              if (drawer) {
                drawer.classList.remove("is-empty");
              }
            })
            .catch((error) => {
              // Handle any errors that occur during the request
              console.error("Error adding item to cart:", error);
            });
        } else {
          console.error("Could not find product form for sticky CTA");
        }
      }
    });
  },
  false
);

// Find all product options
const productOptions = document.querySelectorAll(".cta-qa__option");

// Function to update the button state
function updateButtonState() {
  // Check if the clicked option has data-quantity attribute
  const clickedOption = event.target;
  if (clickedOption) {
    const quantity = clickedOption.getAttribute("data-quantity");

    if (quantity === "0") {
      // Add the class disabled_cta to the submit button
      submitButton.classList.add("disabled_cta");
    } else {
      // Remove the class disabled_cta from the submit button
      submitButton.classList.remove("disabled_cta");
    }
  }
}

if (window.innerWidth > 1024) {
  const pdpHero = document.querySelector(".pdp-hero-wrapper");
  const ctaQa = document.querySelector(".cta-qa");

  function addRemoveStickyClass() {
    const pdpHeroRect = pdpHero.getBoundingClientRect();

    if (pdpHeroRect.bottom <= 0) {
      ctaQa.classList.add("cta-qa--active");
    } else {
      ctaQa.classList.remove("cta-qa--active");
    }
  }

  // Initial check on page load to handle responsive behavior
  addRemoveStickyClass();

  window.addEventListener("scroll", addRemoveStickyClass);
  window.addEventListener("resize", addRemoveStickyClass); // Listen for window resize events
} else if (window.innerWidth <= 1024) {
  document.addEventListener("DOMContentLoaded", function () {
    const ctaQa = document.querySelector(".cta-qa");
    let observer = null;
    let retryCount = 0;
    const maxRetries = 10;
    
    function setupObserver() {
      // Try to find the main Add to Cart button using the data attribute
      const addToCartButton = document.querySelector('[data-add-to-cart-button]');
      
      if (!addToCartButton) {
        // If button not found and we haven't exceeded retry limit, try again after delay
        if (retryCount < maxRetries) {
          retryCount++;
          setTimeout(setupObserver, 500);
          return;
        }
        // Fallback: show the floating CTA if no button found after retries
        ctaQa.classList.add("cta-qa--active");
        return;
      }

      // Reset retry count when button is found
      retryCount = 0;

      // Clean up existing observer
      if (observer) {
        observer.disconnect();
        observer = null;
      }

      // Create intersection observer
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Add to Cart button is visible, hide floating CTA
              ctaQa.classList.remove("cta-qa--active");
            } else {
              // Add to Cart button is not visible, show floating CTA
              ctaQa.classList.add("cta-qa--active");
            }
          });
        },
        {
          root: null,
          rootMargin: '20px', // Add some margin to trigger slightly before/after
          threshold: 0.1 // Trigger when at least 10% of the button is visible
        }
      );

      observer.observe(addToCartButton);
    }

    // Initial setup
    setupObserver();

    // Re-setup observer on window resize to handle responsive changes
    let resizeTimeout;
    window.addEventListener("resize", function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        if (window.innerWidth <= 1024) {
          setupObserver();
        } else if (observer) {
          observer.disconnect();
          observer = null;
          ctaQa.classList.remove("cta-qa--active");
        }
      }, 100);
    });

    // Handle dynamic content changes (e.g., AJAX updates) with debouncing
    let mutationTimeout;
    const mutationObserver = new MutationObserver(function(mutations) {
      clearTimeout(mutationTimeout);
      mutationTimeout = setTimeout(function() {
        // Only re-setup if we're still on mobile
        if (window.innerWidth <= 1024) {
          setupObserver();
        }
      }, 200);
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Handle Shopify section reloads
    document.addEventListener('shopify:section:load', function() {
      if (window.innerWidth <= 1024) {
        setTimeout(setupObserver, 100);
      }
    });
  });
}

const options = document.querySelectorAll(".cta-qa__option");

const submit = document.querySelector(".cta-qa__submit");
const submitSpan = submit.querySelector("span");

options.forEach((option) => {
  option.addEventListener("click", () => {
    const quantity = option.getAttribute("data-quantity");

    if (quantity === "0") {
      submit.classList.add("disabled_sticky_atc");
    } else {
      submit.classList.remove("disabled_sticky_atc");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var submitElement = document.querySelector(
    '.cta-qa__submit[variation-quantity="0"]'
  );

  if (submitElement) {
    submitElement.classList.add("quantity_zero");
  }
});
